import { render, staticRenderFns } from "./PHome.vue?vue&type=template&id=a09bc5c4&scoped=true"
import script from "./PHome.vue?vue&type=script&lang=js"
export * from "./PHome.vue?vue&type=script&lang=js"
import style0 from "./PHome.vue?vue&type=style&index=0&id=a09bc5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09bc5c4",
  null
  
)

export default component.exports